import {Injectable} from '@angular/core';
import {LogoutStrategy} from './logout-strategy';
import {LogoutConfirmService} from '../logout-confirm.service';
import {tap} from 'rxjs/operators';
import {environment} from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CustomerLogoutStrategy implements LogoutStrategy {

  constructor(private readonly logoutConfirmService: LogoutConfirmService) {}

  execute(uuid: string): void {
    this.logoutConfirmService.deleteUserDetails(uuid).pipe(
      tap(() => {
        localStorage.clear();
        window.location.href =
          `${environment.auth0Domain}/v2/logout?client_id=${environment.auth0ClientId}&returnTo=` +
          encodeURIComponent(environment.redirectUrl);
      })
    ).subscribe();
  }
}
